import { Component, OnInit,  ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CatalogService } from '@catalog/catalog.service';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { NgForm } from '@angular/forms';
import { DigitalFactsheet, Year, Month } from './catalogue-digital-factsheet.model';
import {Invalid_URL} from '@root/app.constant';

@Component({
  selector: 'app-catalogue-digital-factsheet',
  templateUrl: './catalogue-digital-factsheet.component.html',
  styleUrls: ['./catalogue-digital-factsheet.component.scss']
})
export class CatalogueDigitalFactsheetComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;

  public digitalFactsheetDataObj = new DigitalFactsheet();

  public yearList:Year[] = [];

  public monthList:Month[] =  [];

  public digitalFactsheetList = new DigitalFactsheet();

  constructor(private toastr: ToastrService, 
    private catalogService: CatalogService, 
    private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.readYear();
    this.readMonth();
    this.readDigitalFactsheet();
  }

  public processData() {
    const url = this.digitalFactsheetDataObj.digitalFactsheetUrl
    let valid = /^(ftp|http|https):\/\/[^ "]+$/.test(url);
    if(!valid){
      this.toastr.error(Invalid_URL);
      return;
    }
    this.digitalFactsheetDataObj.year = ""
    this.digitalFactsheetDataObj.month = ""
      this.catalogService.addDigitalFactsheet(this.digitalFactsheetDataObj).subscribe(
        response => {
          if (response.status === 0) {
            this.toastr.success(response.message);
            this.readDigitalFactsheet();
          }
          this.errorHandler.handleError(response);
          this.resetData();
        },
        error => {
          this.errorHandler.handleError(error);
        }
      )
   
  }

  public resetData(){
    this.form.resetForm();
  };


  public readYear(){
    const obj = {
      flag : ''
    }
    this.catalogService.getYear(obj).subscribe(
      response => {
        if (response.status === 0) {
          this.yearList = response.data.yearList;
        }
        this.errorHandler.handleError(response);
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public readMonth(){
    this.catalogService.getMonth().subscribe(
      response => {
        if (response.status === 0) {
         this.monthList = response.data.monthList;
        }
        this.errorHandler.handleError(response);
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public readDigitalFactsheet(selectedYear?: string) {
    const obj = {
      year : selectedYear ? selectedYear : ''
    };
    this.catalogService.readDigitalFactsheet(obj).subscribe(
      (response) => {
        if(response.status === 0){
          this.digitalFactsheetList = response.data.digitalFactsheetReturnValue;
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  keyPressURL(event: any) {
    const pattern = /[a-zA-Z0-9:/.$-_ . + ! *'( )]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  

}
